import React from 'react';

import language from '../../assets/languages/language';
import config from '../../views/config/App_data';

function ReportQuestion({ onClick, className , reportTooltipText = language.LC().REPORT_THIS_QUESTION}) {
  return (
    <span className={`${className || ''} up tooltip-hover-questions`}>
      <div className='tootip_box'> {reportTooltipText} </div>
      <div className='report-icon-wrapper' onClick={onClick}>
        <img src={`${config.frontend_url}/img/report4.png`} alt='report' />
      </div>
    </span>
  );
}

export default ReportQuestion;



// WEBPACK FOOTER //
// ./src/Components-2025/QuestionBank/ReportQuestion.jsx